<template>
  <div v-if="document" class="blog">
    <div class="container mt-2 mt-md-4 mb-2 mb-md-4">
      <h1 class="h1 text-center">{{ document.title }}</h1>
    </div>

    <blog-list :type="document.list_type" show-search />
  </div>
</template>

<script>
import ScrollTrackingMixin from '@/mixins/ScrollTrackingMixin'
import BlogList from '@/components/blog/BlogList'

import services from '@/services'

import { ORIGIN } from '@/const'

export default {
  name: 'News',
  components: {
    BlogList,
  },
  mixins: [ScrollTrackingMixin],
  async asyncData({ params, i18n, $logError, error }) {
    try {
      // Query to get post content
      const document = await services.sanityService
        .getBlog({
          uid: params.type,
          lang: i18n.locale.slice(0, 2),
        })
        .then((res) => {
          if (res.length > 0) {
            return res[0]
          }

          return undefined
        })

      if (!document) {
        throw new Error('blog-not-found')
      }

      // Returns data to be used in template
      return {
        document,
      }
    } catch (e) {
      // Returns error page
      // if (e.message !== 'blog-not-found') {
      $logError.captureException(e)
      // }
      error({
        statusCode: 404,
        message: `Blog ${params.type}-${params.context} not found for locale ${i18n.locale}`,
      })
    }
  },
  data() {
    return {
      document: null,
      ORIGIN,
    }
  },
  head() {
    if (this.document) {
      const title = `${this.document.title} - ${this.$t(
        `context.${this.$route.params.context}`
      )}`

      const route = `${
        process.env.BASE_URL ? process.env.BASE_URL : 'https://www.asphalte.com'
      }${this.$nuxt.$route.path}`

      return services.pageService.getHead(
        {
          type: 'blog',
          title,
          route,
          sanity: this.document,
          defaultTitle: this.$t('seo.defaultTitle'),
          defaultDesc: this.$t('seo.defaultDesc'),
        },
        this.$generateAlternateLinksMetaSanity(
          this.document._type,
          this.document.alternate_languages
        )
      )
    }

    return {}
  },
  mounted() {
    this.$track.page(this.$metaInfo, this.$route, this.$nuxt.context.from)
  },
}
</script>
